import { Panel } from "../../../components/panels/Panel";
import RGL, { WidthProvider } from "react-grid-layout";
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { ErgonomicsCard } from "./ErgonomicsCard";
import "../../../styles/card_placeholder.scss";
import { ErgonomicsCardSynthesis } from "./cards/ErgonomicsCardSynthesis";
import { ErgonomicsCardMainGraphs } from "./cards/ErgonomicsCardMainGraphs";
import { ErgonomicsCardDetailsGraphs } from "./cards/ErgonomicsCardDetailsGraphs";
import { ErgonomicsCardTimeline } from "./cards/ErgonomicsCardTimeline";
import { saveLayout } from "../../../services/ergonomics/ergonomics-service";
import { useErgonomicsContext } from "../../../contexts/ErgonomicsContext";
import { ErgonomicsCardNotes } from "./cards/ErgonomicsCardNotes";
import { ErgonomicsCardDataRequest } from "./cards/ErgonomicsCardDataRequest";
import { ErgonomicsCardData } from "./cards/ErgonomicsCardData";
import { ErgonomicsCardMainDetailsGraphs } from "./cards/ErgonomicsCardMainDetailsGraphs";

const GridLayout = WidthProvider(RGL);

export const ErgonomicsMainPanel = () => {

  const { layout, setLayout, isEditingLayout } = useErgonomicsContext();

  const handleLayoutChange = (newLayout) => {
    setLayout(newLayout);
    saveLayout(newLayout);
  };

  return (
    <Panel title="EXPLORATION DES DONNEES" category="main">
      {/* This div is necessary to consider Panel bottom padding*/}
      <div>
        <GridLayout
          className="layout pb-4"
          layout={layout}
          cols={4}
          rowHeight={200}
          containerPadding={[0, 0]}
          onLayoutChange={handleLayoutChange}
          isDraggable={isEditingLayout}
          isResizable={isEditingLayout}
          isBounded={true}
          autoSize={true}
          useCSSTransforms={true}
        >
          <div key="main-graphs">
            <ErgonomicsCard>
              <ErgonomicsCardMainGraphs/>
            </ErgonomicsCard>
          </div>
          <div key="timeline">
            <ErgonomicsCard>
              <ErgonomicsCardTimeline/>
            </ErgonomicsCard>
          </div>
          <div key="data">
            <ErgonomicsCard>
              <ErgonomicsCardData/>
            </ErgonomicsCard>
          </div>
          <div key="data-requests">
            <ErgonomicsCard>
              <ErgonomicsCardDataRequest/>
            </ErgonomicsCard>
          </div>
          <div key="notes">
            <ErgonomicsCard>
              <ErgonomicsCardNotes/>
            </ErgonomicsCard>
          </div>
          <div key="synthesis">
            <ErgonomicsCard>
              <ErgonomicsCardSynthesis/>
            </ErgonomicsCard>
          </div>
          <div key="main-details-graphs">
            <ErgonomicsCard>
              <ErgonomicsCardMainDetailsGraphs/>
            </ErgonomicsCard>
          </div>
          <div key="details-graphs">
            <ErgonomicsCard>
              <ErgonomicsCardDetailsGraphs/>
            </ErgonomicsCard>
          </div>
        </GridLayout>
      </div>
    </Panel>
  );
};
